import api from './api'
export const sharingService = {
  // Send report by email
  sendReportByEmail: async (documentId: string, recipientEmail: string) => {
    const reportLink = `${window.location.origin}/relatorio/${documentId}`
    const response = await api.post(
      `/api/semantic-branding/${documentId}/share-email`,
      {
        recipientEmail,
        reportLink,
      },
    )
    return response.data
  },
}
